import { Thing } from "../_models/thing";
import { Injectable } from "@angular/core";
import { ThingUserAccess } from "../_models/thingUserAccess";
import { ThingStatusAccess } from "../_models/thingStatusAccess";
import { ThingControlAccess } from "../_models/thingControlAccess";
import { ThingsLocation } from "../_models/thingsLocation";
import { ThingsManufactureDetails } from "../_models/thingsManufactureDetails";
import { ThingAccessories } from "../_models/thingAccessories";
import { ThingStatus } from "../_models/thingStatus";
import { ThingControl } from "../_models/thingControl";
import { AdminUser } from "../_models/adminuser";
import { AuthenticationService } from "./authentication.service";

import { MissionService } from "./mission.service";
import { ThingUiObject } from "../_models/thingUiObject";
import {
  NgxIndexedDBModule,
  DBConfig,
  NgxIndexedDBService
} from "ngx-indexed-db";



const dbConfig: DBConfig = {
  name: "thingDatabase",
  version: 1,
  objectStoresMeta: [
    {
      store: "Things",
      storeConfig: { keyPath: "macId", autoIncrement: false },
      storeSchema: [
        { name: "Thing", keypath: "thing", options: { unique: true } }
      ]
    },
    {

      store: 'thingUiObject',
      storeConfig: { keyPath: 'uiMacId', autoIncrement: false },
      storeSchema: [
        { name: 'Thing', keypath: 'thing', options: { unique: true } },
      ]
    },
    {

      store: 'locationList',
      storeConfig: { keyPath: 'id', autoIncrement: false },
      storeSchema: [
        { name: 'name', keypath: 'name', options: { unique: true } },
      ]
    },
  ]
};

export const dbrouting = NgxIndexedDBModule.forRoot(dbConfig);
@Injectable()
export class DataStore {

  currentUser: AdminUser;
  thingUIObject: Map<string, ThingUiObject> = new Map<string, ThingUiObject>();
  updateFor: string;
  selectedThingObject: Thing;
  private db: any;
  thingDataMapGlobal: any;
  returnData: any;

  constructor(
    private authService: AuthenticationService,

    private missionService: MissionService,
    private dbService: NgxIndexedDBService
  ) { }

  public parseThingData(syncdata: any) {
    syncdata.forEach(thingsSyncData => {
      if (thingsSyncData.thing.status) {
        if (thingsSyncData.type === "thing") {
          this.currentUser = this.authService.currentUserValue;
          //Parsing Admin Json
          if (thingsSyncData.admin) {
            var admin: Array<string> = new Array<string>();
            admin = thingsSyncData.admin;
          }
          //Parsing UserAccess Json
          var thingUserAccess: Array<ThingUserAccess> = new Array<ThingUserAccess>();
          if (thingsSyncData.thing["userAccess"]) {
            thingsSyncData.thing["userAccess"].forEach(userAccessId => {
              var userGroupName = userAccessId.name;
              var userList: Array<string> = userAccessId.userList;
              var enabledStatuses: Array<string> = userAccessId.status;
              var enabledControls: Array<string> = userAccessId.controls;
              let userAccess: ThingUserAccess = new ThingUserAccess(
                userGroupName,
                userList,
                enabledStatuses,
                enabledControls
              );
              thingUserAccess.push(userAccess);
              // console.log(thingUserAccess)
            });
          }
          //Parsing Thing Location
          let thingLocation: ThingsLocation = new ThingsLocation(
            thingsSyncData.thing.location.placeId,
            thingsSyncData.thing.location.placeType,
            thingsSyncData.thing.location.placeName,
            thingsSyncData.thing.location.latitude,
            thingsSyncData.thing.location.longitude,
            thingsSyncData.thing.location.canEditLocation
          );
          //Parsing Thing Manufacture Details
          let thingManufactureDetails: ThingsManufactureDetails = new ThingsManufactureDetails(
            thingsSyncData.thing.manufacturerDetails.modelNumber,
            thingsSyncData.thing.manufacturerDetails.modelName,
            thingsSyncData.thing.manufacturerDetails.serialNumber,
            thingsSyncData.thing.manufacturerDetails.manufacturer,
            thingsSyncData.thing.manufacturerDetails.manufacturerURL
          );
          //Parsing Thing Accessory
          var thingAccessories: Array<ThingAccessories> = new Array<ThingAccessories>();
          var thingAccessoriesy;
          if (thingsSyncData.thing.thingType === "laptop") {
            if (thingsSyncData.thing.accessories.laptop) {
              thingAccessoriesy = thingsSyncData.thing.accessories.laptop;
              let thingAccessory: ThingAccessories = new ThingAccessories(thingsSyncData.macId, "", "laptop", thingsSyncData.thing.accessoriesDetails["laptop"].name, thingsSyncData.thing.roomName, thingsSyncData.thing.accessories.laptop.status, thingsSyncData.thing.accessories.laptop.controls, "laptop", thingAccessoriesy.isLinkingAvailable, thingAccessoriesy.canChangeThingType, "", "", thingsSyncData.thing.isLinkableThing);
              thingAccessories.push(thingAccessory);
            }
          } else {
            var thingAccessories: Array<ThingAccessories> = new Array<ThingAccessories>();
            if (thingsSyncData.thing.accessories) {
              Object.keys(thingsSyncData.thing.accessories).forEach(accessoryId => {
                var accessoryJson = thingsSyncData.thing.accessories[accessoryId];
                if (thingsSyncData.thing.status) {
                  var accessoryStatusJson = thingsSyncData.thing.status;
                  var accessoryControlJson = accessoryJson.controls;
                  var thingStatus: Array<ThingStatus> = new Array<ThingStatus>();
                  var thingControls: Array<ThingControl> = new Array<ThingControl>();
                  if (this.currentUser && admin.includes(this.currentUser.phoneNumber)) {
                    //Parsing Status Json for Admins
                    Object.keys(accessoryStatusJson).forEach(statusID => {
                      var id = ""
                      if (statusID.split("/").length > 1) {
                        id = statusID.split("/")[1];
                      } else {
                        id = statusID;
                      }
                      var currentStateArray: Array<Map<string, [string]>> = new Array<Map<string, [string]>>();
                      for (var currentStateKey in accessoryStatusJson[statusID]) {
                        if (thingsSyncData.thing.buildNumber >= 6) {
                          currentStateArray.push(new Map<string, [string]>().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey]));
                        } else if (accessoryStatusJson[statusID][currentStateKey][id]) {
                          currentStateArray.push(new Map<string, [string]>().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey][id][0]));
                        } else {
                          // console.log("Accessory JSON CHECK < 6", id, thingsSyncData.macId, accessoryStatusJson[statusID], thingsSyncData.thing.buildNumber);
                          // for (var stateId in accessoryStatusJson[statusID]) {
                          //   console.log("StatusId", thingsSyncData.macId, accessoryStatusJson[statusID][stateId])
                          // }
                        }
                        if (statusID.includes(accessoryId)) {
                          if (accessoryJson.status[id]) {
                            let status: ThingStatus = new ThingStatus(id, accessoryJson.status[id].linkDisplayName, currentStateArray, accessoryJson.status[id].topicName, accessoryId, thingsSyncData.macId, accessoryJson.status[id].hasStatusImage, accessoryJson.status[id].iconType, accessoryJson.status[id].linkIconType, accessoryJson.status[id].linkDisplayName);
                            thingStatus.push(status);
                          }
                        }
                      }
                    });

                    //Parsing Control Json admins
                    Object.keys(accessoryControlJson).forEach(controlID => {
                      var availableControl: Array<Map<string, [string]>> = new Array<Map<string, [string]>>();
                      accessoryControlJson[controlID].states.forEach(availableStates => {
                        for (var statesKey in availableStates) {
                          availableControl.push(new Map<string, [string]>().set(statesKey, availableStates[statesKey]));
                        }
                      });
                      let control: ThingControl = new ThingControl(thingsSyncData.macId, controlID, accessoryControlJson[controlID].type, accessoryControlJson[controlID].topicName, availableControl, accessoryId, accessoryControlJson[controlID].linkDisplayName, accessoryControlJson[controlID].iconType, accessoryControlJson[controlID].hasControlImage, accessoryControlJson[controlID].isConfirmationRequired, accessoryControlJson[controlID].linkIconType, accessoryControlJson[controlID].linkDisplayName);
                      thingControls.push(control);
                    });
                  }
                  else {
                    thingUserAccess.forEach(userAccess => {
                      if (userAccess.userList.includes(this.currentUser.phoneNumber)) {

                        //Parsing Status Json for Admins
                        if (userAccess.controlAccess.length > 0) {
                          Object.keys(accessoryStatusJson).forEach(statusID => {
                            var id = ""
                            if (statusID.split("/").length > 1) {
                              id = statusID.split("/")[1];
                            } else {
                              id = statusID;
                            }
                            var currentStateArray: Array<Map<string, [string]>> = new Array<Map<string, [string]>>();
                            for (var currentStateKey in accessoryStatusJson[statusID]) {
                              if (thingsSyncData.thing.buildNumber >= 6) {
                                currentStateArray.push(new Map<string, [string]>().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey]));
                              } else if (accessoryStatusJson[statusID][currentStateKey][id]) {
                                currentStateArray.push(new Map<string, [string]>().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey][id][0]));
                              } else {
                                // console.log("Accessory JSON CHECK < 6", id, thingsSyncData.macId, accessoryStatusJson[statusID], thingsSyncData.thing.buildNumber);
                                // for (var stateId in accessoryStatusJson[statusID]) {
                                //   console.log("StatusId", thingsSyncData.macId, accessoryStatusJson[statusID][stateId])
                                // }
                              }
                              if (statusID.includes(accessoryId)) {
                                if (accessoryJson.status[id]) {
                                  let status: ThingStatus = new ThingStatus(id, accessoryJson.status[id].linkDisplayName, currentStateArray, accessoryJson.status[id].topicName, accessoryId, thingsSyncData.macId, accessoryJson.status[id].hasStatusImage, accessoryJson.status[id].iconType, accessoryJson.status[id].linkIconType, accessoryJson.status[id].linkDisplayName);
                                  thingStatus.push(status);
                                }
                              }
                            }
                          });
                        }
                        //Parsing Control Json admins
                        Object.keys(accessoryControlJson).forEach(controlID => {

                          var accessFor = accessoryId + "/" + accessoryControlJson[controlID]["topicName"];

                          if (userAccess.controlAccess.includes(accessFor)) {
                            // console.log("Control ID", thingsSyncData.macId, controlID);
                            var availableControl: Array<Map<string, [string]>> = new Array<Map<string, [string]>>();
                            accessoryControlJson[controlID].states.forEach(availableStates => {
                              for (var statesKey in availableStates) {
                                // console.log("Control ID", thingsSyncData.macId, controlID, availableStates, statesKey);
                                availableControl.push(new Map<string, [string]>().set(statesKey, availableStates[statesKey]));
                              }
                            });
                            let control: ThingControl = new ThingControl(thingsSyncData.macId, controlID, accessoryControlJson[controlID].type, accessoryControlJson[controlID].topicName, availableControl, accessoryId, accessoryControlJson[controlID].linkDisplayName, accessoryControlJson[controlID].iconType, accessoryControlJson[controlID].hasControlImage, accessoryControlJson[controlID].isConfirmationRequired, accessoryControlJson[controlID].linkIconType, accessoryControlJson[controlID].linkDisplayName);
                            thingControls.push(control);
                          }
                        });
                        // console.log("USER access", thingControls)
                      }
                    });

                  }
                }
                if (thingsSyncData.thing.accessoriesDetails[accessoryId] != undefined) {
                  let thingAccessory: ThingAccessories = new ThingAccessories(
                    thingsSyncData.macId,
                    "",
                    accessoryId,
                    thingsSyncData.thing.accessoriesDetails[accessoryId].name,
                    thingsSyncData.thing.roomName || "",
                    thingStatus,
                    thingControls,
                    thingsSyncData.thing.accessoriesDetails[
                      accessoryId
                    ].accessoryType,
                    accessoryJson.isLinkingAvailable,
                    accessoryJson.canChangeType,
                    thingsSyncData.thing.accessoriesDetails[
                      accessoryId
                    ].linkingDetails.addLinkMacId,
                    thingsSyncData.thing.accessoriesDetails[
                      accessoryId
                    ].linkingDetails.removeLinkMacId,
                    thingsSyncData.thing.isLinkableThing
                  );
                  thingAccessories.push(thingAccessory);
                }
              });
            }
          }
          let isOnline: boolean;
          if (thingsSyncData.thing.status) {
            if (thingsSyncData.thing.status.Connectivity) {

              if (thingsSyncData.thing.status.Connectivity.Connectivity) {
                if (
                  thingsSyncData.thing.status.Connectivity.Connectivity ===
                  "Offline"
                ) {
                  isOnline = false;
                } else if (
                  thingsSyncData.thing.status.Connectivity.Connectivity ===
                  "Online"
                ) {
                  isOnline = true;
                }
              }
            }
          }
          let thingInfo;
          if (thingsSyncData.thing.status) {
            if (thingsSyncData.thing.status.info) {
              thingInfo = thingsSyncData.thing.status.info;
            } else {
              thingInfo = ""
            }
          } else {
            thingInfo = ""
          }
          let thingID,
            thingMacId,
            thingAction,
            thingTimeStamp,
            thingType,
            thingBuildNumber,
            thingCanChangeThingType,
            thingIsLinkableThing,
            thingModel,
            thingVersion,
            thingInitialModel,
            thingInitialVersion,
            thingGroupBy;
          if (thingsSyncData) {
            if (thingsSyncData._id) {
              thingID = thingsSyncData._id;
            }
            else {
              thingID = ""
            }
            if (thingsSyncData.macId) {
              thingMacId = thingsSyncData.macId;
            } else {
              thingMacId = ""
            }
            if (thingsSyncData.action) {
              thingAction = thingsSyncData.action;
            } else {
              thingAction = ""
            }

            if (thingsSyncData.timeStamp) {
              thingTimeStamp = thingsSyncData.timeStamp;
            } else {
              thingTimeStamp = ""
            }
            if (thingsSyncData.thing) {
              if (thingsSyncData.thing.thingType) {
                thingType = thingsSyncData.thing.thingType;
              } else {
                thingType = ""
              }
              if (thingsSyncData.thing.groupBy) {
                thingGroupBy = thingsSyncData.thing.groupBy;
              } else {
                thingGroupBy = ""
              }
              if (thingsSyncData.thing.buildNumber) {
                thingBuildNumber = thingsSyncData.thing.buildNumber;
              }
              else {
                thingBuildNumber = 0
              }
              if (thingsSyncData.thing.canChangeThingType) {
                thingCanChangeThingType = thingsSyncData.thing.canChangeThingType;
              } else {
                thingCanChangeThingType = ""
              }
              if (thingsSyncData.thing.isLinkableThing) {
                thingIsLinkableThing = thingsSyncData.thing.isLinkableThing;
              } else {
                thingIsLinkableThing = ""
              }
              if (thingsSyncData.thing.model) {
                thingModel = thingsSyncData.thing.model;
              } else {
                thingModel = ""
              }
              if (thingsSyncData.thing.version) {
                thingVersion = thingsSyncData.thing.version;
              } else {
                thingVersion = ""
              }
              if (thingsSyncData.thing.isLinkableThing != null) {
                thingIsLinkableThing = thingsSyncData.thing.isLinkableThing;
              } else {
                thingIsLinkableThing = ""
              }

              if (thingsSyncData.thing.accessoriesDetails) {
                if (thingsSyncData.thing.accessoriesDetails.initialModel) {
                  thingInitialModel =
                    thingsSyncData.thing.accessoriesDetails.initialModel;
                } else {
                  thingInitialModel = ""
                }

                if (thingsSyncData.thing.accessoriesDetails.initialVersion) {
                  thingInitialVersion =
                    thingsSyncData.thing.accessoriesDetails.initialVersion;
                } else {
                  thingInitialVersion = ""
                }
              }
            }
          }

          {
            let thing: Thing = new Thing(
              thingID,
              thingMacId,
              thingID,
              thingAction,
              thingType,
              thingGroupBy,
              thingTimeStamp,
              thingBuildNumber,
              thingLocation,
              thingsSyncData.thing.roomName || "",
              thingAccessories,
              thingInfo,
              admin,
              thingUserAccess,
              isOnline,
              thingManufactureDetails,
              true,
              false,
              thingCanChangeThingType,
              thingIsLinkableThing,
              thingModel,
              thingVersion,
              thingInitialModel,
              thingInitialVersion
            );
            if (thing.action == "update" || thing.action == "insert") {
              this.dbService.update('Things', { macId: thingsSyncData.macId, thing: thing }).then(() => {
              });
            }
          }
        }
      }
    });
    this.missionService.announceMission("DataSaved");
  }

  public getAllThingData() {
    this.thingUIObject.clear();
    this.dbService.getAll('Things').then(allThingData => {

      allThingData.forEach(thing =>

        thing['thing']['accessories'].forEach(accessory => {

          if (accessory.statusList) {
            if (accessory.statusList.length != 0) {
              if (accessory.statusList.length > 1) {
                accessory.statusList.forEach(status => {
                  var controlTopic: string;
                  var currentStates: [string];
                  var imageUrl =
                    "https://cogcons-things.s3.ap-south-1.amazonaws.com/things/";
                  var checkPower = status.statusId;

                  if (checkPower == "power") {
                    status.currentState.forEach(states => {
                      states.forEach(state => {
                        currentStates = state;
                      });
                    });
                    if (status.hasStatusImage && currentStates.length > 0) {
                      imageUrl =
                        imageUrl +
                        thing['thing']['manufacturerDetails'].manufacturer +
                        "/" +
                        accessory.accessoryType +
                        "/" +
                        status.iconType +
                        "/" +
                        currentStates +
                        ".png";
                    } else {
                      imageUrl =
                        imageUrl +
                        thing['thing']['manufacturerDetails'].manufacturer +
                        "/" +
                        accessory.accessoryType +
                        "/" +
                        status.iconType +
                        ".png";
                    }
                    if (accessory.thingControl.length != 0) {
                      accessory.thingControl.forEach(control => {
                        if (control.controlIdentifier == "power") {
                          controlTopic = control.topic;
                        }
                      });
                    }
                    let thingUiObject: ThingUiObject = new ThingUiObject(
                      thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                      thing['thing'].macId,
                      thing['thing'].buildNumber,
                      imageUrl.toLowerCase().replace(/ /g, "_"),
                      accessory.thingName,
                      thing['thing'].thingsLocation.placeType,
                      thing['thing'].isNewlyAdded,
                      thing['thing'].isOnline,
                      currentStates,
                      status.topic,
                      controlTopic,
                      thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName
                    );

                    this.thingUIObject.set(
                      thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                      thingUiObject
                    );

                    this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject })

                  }
                });
              } else {
                var controlTopic: string;
                var currentStates: [string];
                var imageUrl =
                  "https://cogcons-things.s3.ap-south-1.amazonaws.com/things/";

                if (accessory.statusList[0]) {
                  {
                    if (accessory.statusList[0].currentState[0]) {
                      accessory.statusList[0].currentState[0].forEach(states => {
                        currentStates = states;

                      });
                    }
                  }
                  if (accessory.statusList[0].hasStatusImage) {
                    imageUrl =
                      imageUrl +
                      thing['thing'].manufacturerDetails.manufacturer +
                      "/" +
                      accessory.accessoryType +
                      "/" +
                      accessory.statusList[0].iconType +
                      "/" +
                      currentStates +
                      ".png";
                  } else {
                    imageUrl =
                      imageUrl +
                      thing['thing'].manufacturerDetails.manufacturer +
                      "/" +
                      accessory.accessoryType +
                      "/" +
                      accessory.statusList[0].iconType +
                      ".png";
                  }

                  if (accessory.thingControl[0] != undefined) {
                    controlTopic = accessory.thingControl[0].topic;
                  }
                  let thingUiObject: ThingUiObject = new ThingUiObject(
                    thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                    thing['thing'].macId,
                    thing['thing'].buildNumber,
                    imageUrl.toLowerCase().replace(/ /g, "_"),
                    accessory.thingName,
                    thing['thing'].thingsLocation.placeType,
                    thing['thing'].isNewlyAdded,
                    thing['thing'].isOnline,
                    currentStates,
                    accessory.statusList[0].topic,
                    controlTopic,
                    thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName
                  );

                  this.thingUIObject.set(
                    thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                    thingUiObject
                  );
                  this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject })

                } else if (thing['thing'].thingType === "laptop") {
                  if (accessory.statusList.lock) {
                    if (
                      accessory.statusList.lock.currentStatus[0].lock[0] ===
                      "UNLOCK"
                    ) {
                      imageUrl =
                        imageUrl + "cogcons_pvt_ltd/laptop/power/off.png";
                    } else if (
                      accessory.statusList.lock.currentStatus[0].lock[0] ===
                      "LOCK"
                    ) {
                      imageUrl =
                        imageUrl + "cogcons_pvt_ltd/laptop/power/on.png";
                    }
                  }

                  if (accessory.thingControl[0] != undefined) {
                    controlTopic = accessory.thingControl[0].topic;
                  }
                  let thingUiObject: ThingUiObject = new ThingUiObject(
                    thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                    thing['thing'].macId,
                    thing['thing'].buildNumber,
                    imageUrl.toLowerCase(),
                    accessory.thingName,
                    thing['thing'].thingsLocation.placeType,
                    thing['thing'].isNewlyAdded,
                    thing['thing'].isOnline,
                    currentStates,
                    accessory.statusList.lock.topic,
                    controlTopic,
                    thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName
                  );

                  this.thingUIObject.set(
                    thing['thing'].macId + "/" + accessory.accessoryIdentifier,
                    thingUiObject
                  );
                  this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject })
                }
              }
            }
          }
        }
        ))

    })
    this.missionService.announceMission("ThingsUpdated")
  }
  deleteDatabase() {
    console.log("in delete")
    this.dbService.clear('Things').then(
      () => {
        console.log("THINGS")
        this.missionService.announceMission("ThingsCleared")
      },
      error => {
        console.log(error);
      }
    );
    this.missionService.missionAnnounced$.subscribe(mission => {
      if (mission === "ThingsCleared") {
        console.log("THING UI OBJECT")
        this.dbService.clear('thingUiObject').then(
          () => {
            this.missionService.announceMission("UiCleared")
          },
          error => {
            console.log(error);
          }
        );

      }
    })
    this.missionService.missionAnnounced$.subscribe(mission => {
      if (mission === "ThingsCleared") {
        console.log("NAME SET OBJECT")
        this.dbService.clear('locationList').then(
          () => {
            console.log("deleted")

          },
          error => {
            console.log(error);
          }
        );

      }
    })


  }

}
